import { render, staticRenderFns } from "./RecordCircle.vue?vue&type=template&id=b70eea40"
import script from "./RecordCircle.vue?vue&type=script&lang=js"
export * from "./RecordCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports